import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@components/form/button';

interface Language {
  key: string;
  value: string;
  name: string;
}

interface LangSwitcherProps {
  active?: string;
  onChange?: (lang: string) => void;
}

export const LangSwitcher = ({ active, onChange }: LangSwitcherProps): ReactElement => {
  const { t, i18n } = useTranslation();

  const changeLanguage = async (lang: string) => {
    if (onChange) {
      onChange(lang);
    } else {
      await i18n.changeLanguage(lang);
    }
  };

  const languages = t('common:languages', { returnObjects: true }) as Language[];

  return (
    <div className="lang-switcher">
      <p>{t('common:chooseLanguage')}</p>

      <div className="lang-options">
        {languages.map((lang) => (
          <Button
            key={lang.value}
            title={lang.name}
            type={lang.value === active ? 'primary' : 'secondary'}
            onClick={() => changeLanguage(lang.value)}
          />
        ))}
      </div>
    </div>
  );
};
